import * as yup from 'yup';

const primeiroAcessoSchema = yup.object().shape({
  email: yup.string().email('Insira um e-mail válido.').required('E-mail obrigatório'),
});

export { primeiroAcessoSchema };